import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useResource } from "@rest-hooks/core";
import { GeneralInfoResource } from "@ploy-lib/rest-resources";
import { Grid, Icon, Link, makeStyles, Typography } from "@material-ui/core";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
const GeneralInformation = (props) => {
    const classes = useStyles();
    const productInfo = useResource(GeneralInfoResource.list(), {}) || [];
    const [expanded, setExpanded] = useState([]);
    const [selected, setSelected] = useState([]);
    const handleToggle = (_, nodeIds) => {
        setExpanded(nodeIds);
    };
    const handleSelect = (_, nodeIds) => {
        setSelected(nodeIds);
    };
    return (_jsx(TreeView, { expanded: expanded, selected: selected, onNodeToggle: handleToggle, onNodeSelect: handleSelect, classes: { root: classes.root }, children: productInfo &&
            productInfo.length > 0 &&
            productInfo.map((info) => (_jsx(TreeItem, { nodeId: `${info.productId}`, label: _jsxs(Grid, { container: true, alignItems: "center", direction: "row", children: [info.productInfoLinks?.length > 0 ? (expanded.some(e => e === info.productId.toString()) ? (_jsx(ExpandMoreIcon, {})) : (_jsx(ChevronRightIcon, {}))) : (_jsx(Icon, {})), _jsx(Typography, { children: info.productName })] }), classes: {
                    iconContainer: classes.iconContainer
                }, children: info.productInfoLinks.map((productInfoLink) => (_jsx(TreeItem, { nodeId: `${productInfoLink.linkId}`, label: _jsx(Grid, { container: true, direction: "row", children: _jsx(Typography, { children: _jsx(Link, { underline: "hover", children: productInfoLink.linkText }) }, productInfoLink.linkId) }), onClick: () => window.open(productInfoLink.linkUrl, "_blank") }, `${productInfoLink.linkId}`))) }, `${info.productId}`))) }));
};
const useStyles = makeStyles(theme => ({
    root: {},
    iconContainer: {
        width: 0
    }
}));
export { GeneralInformation };
//# sourceMappingURL=GeneralInformation.js.map